import React from 'react';

import App from 'catering/App';
import CateringProviders from 'catering/context';
import { NotificationModalRoot } from 'catering/context/providers/NotificationModalProvider';
import ErrorBoundary from 'catering/components/ErrorBoundary';

function CateringApp() {
  // TODO: wrap this in a Profiler
  return (
    <CateringProviders>
      <ErrorBoundary>
        <App />
        <NotificationModalRoot />
      </ErrorBoundary>
    </CateringProviders>
  );
}

export default CateringApp;
